// this is from the BE migration, need to update this when BE adds more old fields
export const OLD_SMART_FIELD_TYPE_TO_NEW_TYPE = {
    event_type: {
        data_source_type: 'project',
        data_source_property: 'project_type'
    },
    event_name: {
        data_source_type: 'project',
        data_source_property: 'event_name'
    },
    event_location: {
        data_source_type: 'project',
        data_source_property: 'event_location'
    },
    event_date: {
        data_source_type: 'project',
        data_source_property: 'event_date'
    },
    event_end_date: {
        data_source_type: 'project',
        data_source_property: 'event_end_date'
    },
    event_time_start: {
        data_source_type: 'project',
        data_source_property: 'event_time_start'
    },
    event_time_end: {
        data_source_type: 'project',
        data_source_property: 'event_time_end'
    },
    event_budget: {
        data_source_type: 'project',
        data_source_property: 'event_budget'
    },
    event_venue_name: {
        data_source_type: 'project',
        data_source_property: 'venue_name'
    },

    agreement_date: {
        data_source_type: 'flow',
        data_source_property: 'contract_date'
    },
    proposal_title: { data_source_type: 'flow', data_source_property: 'title' },

    client_first_name_1: {
        data_source_type: 'first_client',
        data_source_property: 'first_name'
    },
    client_full_name_1: {
        data_source_type: 'first_client',
        data_source_property: 'full_name'
    },
    client_initials_1: {
        data_source_type: 'first_client',
        data_source_property: 'initials'
    },
    client_address_1: {
        data_source_type: 'first_client',
        data_source_property: 'address'
    },
    client_phone_number_1: {
        data_source_type: 'first_client',
        data_source_property: 'phone_number'
    },
    client_email_1: {
        data_source_type: 'first_client',
        data_source_property: 'email'
    },

    client_first_name_2: {
        data_source_type: 'second_client',
        data_source_property: 'first_name'
    },
    client_full_name_2: {
        data_source_type: 'second_client',
        data_source_property: 'full_name'
    },
    client_initials_2: {
        data_source_type: 'second_client',
        data_source_property: 'initials'
    },
    client_address_2: {
        data_source_type: 'second_client',
        data_source_property: 'address'
    },
    client_phone_number_2: {
        data_source_type: 'second_client',
        data_source_property: 'phone_number'
    },
    client_email_2: {
        data_source_type: 'second_client',
        data_source_property: 'email'
    },

    company_name: {
        data_source_type: 'company',
        data_source_property: 'company_name'
    },
    company_email: {
        data_source_type: 'company',
        data_source_property: 'email'
    },
    company_type: {
        data_source_type: 'company',
        data_source_property: 'company_type'
    },
    company_phone_number: {
        data_source_type: 'company',
        data_source_property: 'phone_number'
    },

    company_tax: {
        data_source_type: 'company',
        data_source_property: 'default_tax',
        category: 'Payments'
    },
    proposal_tax: {
        data_source_type: 'invoice',
        data_source_property: 'total_tax'
    },
    proposal_sub_total_price: {
        data_source_type: 'invoice',
        data_source_property: 'sub_total'
    },
    proposal_total_price: {
        data_source_type: 'invoice',
        data_source_property: 'total_price'
    },
    first_payment_amount: {
        data_source_type: 'payments',
        data_source_property: 'amount',
        data_source_sub_property: 0
    },
    first_payment_due_date: {
        data_source_type: 'payments',
        data_source_property: 'due_date',
        data_source_sub_property: 0
    },
    second_payment_amount: {
        data_source_type: 'payments',
        data_source_property: 'amount',
        data_source_sub_property: 1
    },
    second_payment_due_date: {
        data_source_type: 'payments',
        data_source_property: 'due_date',
        data_source_sub_property: 1
    },
    last_payment_amount: {
        data_source_type: 'payments',
        data_source_property: 'amount',
        data_source_sub_property: 2
    },
    last_payment_due_date: {
        data_source_type: 'payments',
        data_source_property: 'due_date',
        data_source_sub_property: 2
    }
};

export const PRESET_CATEGORIES = {
    project: 'Project',
    company: 'Company',
    first_client: 'Client',
    second_client: 'Client',
    third_client: 'Client',
    flow: 'Flow',
    payments: 'Payments',
    suggested: 'Suggested',
    invoice: 'Payments'
};
